import type { CSSProperties, FC } from 'react'
import type { VideoEmbedPropsApi } from '@/features/grid/videoEmbed/models'

const VimeoEmbed: FC<VideoEmbedPropsApi> = props => {
    const { url } = props
    const id = url.substring(url.lastIndexOf('/') + 1)
    const src = `https://player.vimeo.com/video/${id}`

    const style: CSSProperties = {
        width: '100%',
        aspectRatio: '16/9',
    }
    return <iframe src={src} allow="autoplay; fullscreen; picture-in-picture" allowFullScreen style={style} />
}

export default VimeoEmbed
